import Settings from './settings'

export default {
  ...Settings,
  serviceDeskUrl: 'https://acercapartners.atlassian.net/servicedesk/customer/portal/31',
  urlHotFolder: '',
  webSocketUrl: 'wss://toyota.idoccar.com:8006',
  notificationRefresh: 60000,
  showSignDocumentButton: false,
  acceptFileFormats: 'application/pdf, .jpg, .png, .jpeg, .gif, .docx, .doc, .xls, .xlsx, .ppt, .pptx, .msg, .tiff',
  qaSite: false,
  dealerMaxLength: 6,
  dealerNumberRegex: null,
  autoLoadDashboard: true,
  clientFieldValidation: 'toyo',
  validateLicensePlate: true,
  validateSalesManager: false,
  matomoSiteId: '10',
  enableFavoritesAndRecents: true,
  enableTaskFollowUp: true,
  dashboardVersion: 2,
  usersManualUrl: 'https://toyota-formacion-new.idoccar.com/',
  usersManualEnvironment: 'toyota',
  reloadTaskDashboardOnReturn: true,
  showV2Link: true
}
